// import {
//   ShieldCheck,
//   Rocket,
//   Users,
//   Settings,
//   Headphones,
//   Globe,
// } from "lucide-react";
// import { motion } from "framer-motion";

// export default function WhyChooseInfronex() {
//   const reasons = [
//     {
//       icon: <Rocket size={20} />,
//       title: "Future-Ready Engineering",
//       desc: "Architecting scalable systems that evolve alongside your business roadmap.",
//     },
//     {
//       icon: <ShieldCheck size={20} />,
//       title: "Enterprise-Grade Security",
//       desc: "Security-first development lifecycle to protect your intellectual property.",
//     },
//     {
//       icon: <Users size={20} />,
//       title: "Deep Technical Partnership",
//       desc: "Beyond outsourcing—we act as an extension of your internal engineering team.",
//     },
//     {
//       icon: <Settings size={20} />,
//       title: "Full-Cycle Delivery",
//       desc: "From initial concept and MVP to global deployment and cloud management.",
//     },
//     {
//       icon: <Headphones size={20} />,
//       title: "SLA-Backed Support",
//       desc: "Dedicated post-launch maintenance with guaranteed response times.",
//     },
//     {
//       icon: <Globe size={20} />,
//       title: "Global Compliance",
//       desc: "Adherence to international standards for quality, design, and performance.",
//     },
//   ];

//   return (
//     <section className="bg-slate-50 py-24 px-6 overflow-hidden">
//       <div className="max-w-6xl mx-auto">
//         {/* Header Area */}
//         <div className="text-center mb-20">
//           <div className="flex items-center justify-center gap-3 mb-4">
//             <span className="w-8 h-px bg-indigo-600"></span>
//             <span className="text-[11px] font-bold tracking-[0.2em] text-indigo-600 uppercase">
//               The Infronex Advantage
//             </span>
//             <span className="w-8 h-px bg-indigo-600"></span>
//           </div>
//           <h2 className="text-3xl md:text-4xl font-bold text-slate-900 leading-tight">
//             Driving business value through <br />
//             <span className="text-slate-400 font-medium italic">
//               technical excellence.
//             </span>
//           </h2>
//         </div>

//         {/* Grid Area */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {reasons.map((item, index) => (
//             <motion.div
//               key={index}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.5, delay: index * 0.1 }}
//               viewport={{ once: true }}
//               className="group bg-white border border-slate-200 p-8 rounded-2xl shadow-sm hover:shadow-xl hover:shadow-indigo-500/5 hover:border-indigo-500/30 transition-all duration-300 relative overflow-hidden"
//             >
//               {/* Subtle Background Glow on Hover */}
//               <div className="absolute -right-4 -top-4 w-24 h-24 bg-indigo-50 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

//               {/* Icon Container */}
//               <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-slate-50 text-slate-900 mb-6 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 shadow-sm">
//                 {item.icon}
//               </div>

//               <h3 className="text-[17px] font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
//                 {item.title}
//               </h3>

//               <p className="text-[14px] text-slate-500 leading-relaxed font-normal">
//                 {item.desc}
//               </p>

//               {/* Decorative Corner Element */}
//               <div className="absolute bottom-0 right-0 p-2 opacity-5 group-hover:opacity-20 transition-opacity">
//                 <div className="w-8 h-8 border-r-2 border-b-2 border-indigo-600" />
//               </div>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }

// import {
//   ShieldCheck,
//   Rocket,
//   Users,
//   Settings,
//   Headphones,
//   Globe,
// } from "lucide-react";
// import { motion } from "framer-motion";

// // --- IMAGE IMPORTS ---
// import MuruganAyurvedhic from "./Muruganayurvedhic.png";
// import Hariraj from "./Hariraj.png";
// import Csg from "./Csg.png";
// import MuruganBags from "./Muruganbags.jpg";
// import Matrimony from "./Matrimony.png";
// import Svasti from "./Svasti.png";
// import SalFinance from "./Salfinance.png";

// export default function WhyChooseInfronex() {
//   const reasons = [
//     {
//       icon: <Rocket size={24} />,
//       title: "Future-Ready Engineering",
//       desc: "Architecting scalable systems that evolve alongside your business roadmap.",
//     },
//     {
//       icon: <ShieldCheck size={24} />,
//       title: "Enterprise-Grade Security",
//       desc: "Security-first development lifecycle to protect your intellectual property.",
//     },
//     {
//       icon: <Users size={24} />,
//       title: "Deep Technical Partnership",
//       desc: "Beyond outsourcing—we act as an extension of your internal engineering team.",
//     },
//     {
//       icon: <Settings size={24} />,
//       title: "Full-Cycle Delivery",
//       desc: "From initial concept and MVP to global deployment and cloud management.",
//     },
//     {
//       icon: <Headphones size={24} />,
//       title: "SLA-Backed Support",
//       desc: "Dedicated post-launch maintenance with guaranteed response times.",
//     },
//     {
//       icon: <Globe size={24} />,
//       title: "Global Compliance",
//       desc: "Adherence to international standards for quality, design, and performance.",
//     },
//   ];

//   const clients = [
//     { name: "Sri Murugan Ayurvedic", img: MuruganAyurvedhic, color: "#166534" }, // Forest Green
//     { name: "Sri Hariraj", img: Hariraj, color: "#9a3412" }, // Deep Orange
//     { name: "CSG Computer Education", img: Csg, color: "#1e40af" }, // Blue
//     { name: "Sri Murugan Bags", img: MuruganBags, color: "#86198f" }, // Purple
//     { name: "Sri Angalamman Matrimony", img: Matrimony, color: "#be123c" }, // Rose
//     { name: "Svasti", img: Svasti, color: "#111827" }, // Slate
//     { name: "Sal Finance", img: SalFinance, color: "#0369a1" }, // Sky
//     { name: "Gleethreads", isText: true, color: "#db2777" }, // Pink
//     { name: "Velan Medicals", isText: true, color: "#059669" }, // Emerald
//     { name: "Meet and Eat", isText: true, color: "#d97706" }, // Amber
//   ];

//   const duplicatedClients = [...clients, ...clients];

//   return (
//     <>
//       <section className="bg-slate-50 py-24 px-6 overflow-hidden">
//         <div className="max-w-6xl mx-auto">
//           <div className="text-center mb-20">
//             <div className="flex items-center justify-center gap-3 mb-4">
//               <span className="w-12 h-1 bg-indigo-600 rounded-full"></span>
//               <span className="text-xs font-black tracking-[0.3em] text-indigo-600 uppercase">
//                 The Infronex Advantage
//               </span>
//               <span className="w-12 h-1 bg-indigo-600 rounded-full"></span>
//             </div>
//             <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 leading-tight">
//               Driving business value through <br />
//               <span className="text-indigo-600">technical excellence.</span>
//             </h2>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
//             {reasons.map((item, index) => (
//               <motion.div
//                 key={index}
//                 initial={{ opacity: 0, scale: 0.9 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ duration: 0.4, delay: index * 0.1 }}
//                 viewport={{ once: true }}
//                 className="group bg-white border-2 border-slate-100 p-10 rounded-3xl shadow-md hover:shadow-2xl hover:border-indigo-500 transition-all duration-500"
//               >
//                 <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 mb-8 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 shadow-inner">
//                   {item.icon}
//                 </div>
//                 <h3 className="text-xl font-bold text-slate-900 mb-4 tracking-tight">
//                   {item.title}
//                 </h3>
//                 <p className="text-md text-slate-600 leading-relaxed">
//                   {item.desc}
//                 </p>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* --- VIBRANT CLIENTS SECTION --- */}
//       <section className="bg-white py-24 border-t border-slate-100 overflow-hidden">
//         <div className="max-w-6xl mx-auto px-6 mb-20 text-center">
//           <h2 className="text-4xl font-black text-slate-900 mb-4 tracking-tight">
//             Our Trusted Clients
//           </h2>
//           <p className="text-lg text-slate-500 max-w-2xl mx-auto">
//             Supporting industry leaders and growing businesses with robust
//             digital infrastructure.
//           </p>
//         </div>

//         <div className="relative">
//           {/* Stronger Side Fades */}
//           <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-10" />
//           <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-10" />

//           <motion.div
//             className="flex gap-20 items-center whitespace-nowrap"
//             animate={{ x: ["0%", "-50%"] }}
//             transition={{
//               duration: 20, // Faster for more energy
//               repeat: Infinity,
//               ease: "linear",
//             }}
//           >
//             {duplicatedClients.map((client, idx) => (
//               <div
//                 key={idx}
//                 className="flex flex-col items-center justify-center min-w-[250px] group"
//               >
//                 <div className="h-28 w-full flex items-center justify-center mb-6 px-4">
//                   {client.isText ? (
//                     <div
//                       className="px-8 py-3 border-4 rounded-2xl transition-transform group-hover:scale-110 duration-300 shadow-sm"
//                       style={{
//                         borderColor: client.color,
//                         backgroundColor: `${client.color}10`,
//                       }}
//                     >
//                       <span
//                         className="text-2xl font-black tracking-tighter"
//                         style={{ color: client.color }}
//                       >
//                         {client.name}
//                       </span>
//                     </div>
//                   ) : (
//                     <img
//                       src={client.img}
//                       alt={client.name}
//                       className="max-h-24 max-w-[200px] w-auto object-contain drop-shadow-lg transition-transform group-hover:scale-110 duration-300"
//                     />
//                   )}
//                 </div>

//                 <span className="text-sm font-extrabold text-slate-800 tracking-widest uppercase">
//                   {client.name}
//                 </span>
//               </div>
//             ))}
//           </motion.div>
//         </div>
//       </section>
//     </>
//   );
// }

import {
  ShieldCheck,
  Rocket,
  Users,
  Settings,
  Headphones,
  Globe,
} from "lucide-react";
import { motion } from "framer-motion";

// --- IMAGE IMPORTS ---

import MuruganAyurvedhic from "./Muruganayurvedhic.png";
import Hariraj from "./Hariraj.png";
import Csg from "./Csg.png";
import MuruganBags from "./Muruganbags.jpg";
import Matrimony from "./Matrimony.png";
import Svasti from "./Svasti.png";
import SalFinance from "./Salfinance.png";


export default function WhyChooseInfronex() {
  const reasons = [
    {
      icon: <Rocket size={24} />,
      title: "Future-Ready Engineering",
      desc: "Architecting scalable systems that evolve alongside your business roadmap.",
    },
    {
      icon: <ShieldCheck size={24} />,
      title: "Enterprise-Grade Security",
      desc: "Security-first development lifecycle to protect your intellectual property.",
    },
    {
      icon: <Users size={24} />,
      title: "Deep Technical Partnership",
      desc: "Beyond outsourcing—we act as an extension of your internal engineering team.",
    },
    {
      icon: <Settings size={24} />,
      title: "Full-Cycle Delivery",
      desc: "From initial concept and MVP to global deployment and cloud management.",
    },
    {
      icon: <Headphones size={24} />,
      title: "SLA-Backed Support",
      desc: "Dedicated post-launch maintenance with guaranteed response times.",
    },
    {
      icon: <Globe size={24} />,
      title: "Global Compliance",
      desc: "Adherence to international standards for quality, design, and performance.",
    },
  ];

  const clients = [
    { name: "Sri Murugan Ayurvedic", img: MuruganAyurvedhic, color: "#166534" },
    { name: "Sri Hariraj", img: Hariraj, color: "#9a3412" },
    { name: "CSG Computer Education", img: Csg, color: "#1e40af" },
    { name: "Sri Murugan Bags", img: MuruganBags, color: "#86198f" },
    { name: "Sri Angalamman Matrimony", img: Matrimony, color: "#be123c" },
    { name: "Svasti", img: Svasti, color: "#111827" },
    { name: "Sal Finance", img: SalFinance, color: "#0369a1" },
    { name: "Gleethreads", isText: true, color: "#db2777" },
    { name: "Velan Medicals", isText: true, color: "#059669" },
    { name: "Meet and Eat", isText: true, color: "#d97706" },
  ];

  return (
    <>
      {/* --- WHY CHOOSE SECTION (Keep as is) --- */}
      <section className="bg-slate-50 py-24 px-6 overflow-hidden">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-20">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="w-12 h-1 bg-indigo-600 rounded-full"></span>
              <span className="text-xs font-black tracking-[0.3em] text-indigo-600 uppercase">
                The Infronex Advantage
              </span>
              <span className="w-12 h-1 bg-indigo-600 rounded-full"></span>
            </div>
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900 leading-tight">
              Driving business value through <br />
              <span className="text-indigo-600">technical excellence.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {reasons.map((item, index) => (
              <motion.div
                key={index}
                initial={{ scale: 0.95 }}
                whileInView={{ scale: 1 }}
                transition={{ duration: 0.4, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="group bg-white border-2 border-slate-100 p-10 rounded-3xl shadow-md hover:shadow-2xl hover:border-indigo-500 transition-all duration-500"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-indigo-50 text-indigo-600 mb-8 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 shadow-inner">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-4 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-md text-slate-600 leading-relaxed">
                  {item.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* --- VIBRANT CLIENTS SECTION --- */}
      <section className="bg-white py-24 border-t border-slate-100 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6 mb-20 text-center">
          <h2 className="text-4xl font-black text-slate-900 mb-4 tracking-tight">
            Our Trusted Clients
          </h2>
          <p className="text-lg text-slate-500 max-w-2xl mx-auto">
            Supporting industry leaders and growing businesses with robust
            digital infrastructure.
          </p>
        </div>

        <div className="relative">
          {/* Side Fades */}
          <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-white to-transparent z-20" />
          <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-white to-transparent z-20" />

          <motion.div
            className="flex gap-20 items-center whitespace-nowrap"
            style={{ width: "max-content" }} // Forces the div to hold all items in a row
            animate={{ x: ["0%", "-50%"] }}
            transition={{
              duration: 40, // Your original speed
              repeat: Infinity,
              ease: "linear",
            }}
          >
            {/* Mapping twice ensures the loop is seamless */}
            {[...clients, ...clients].map((client, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center justify-center min-w-[250px] group"
              >
                <div className="h-28 w-full flex items-center justify-center mb-6 px-4">
                  {client.isText ? (
                    <div
                      className="px-8 py-3 border-4 rounded-2xl transition-transform group-hover:scale-110 duration-300 shadow-sm"
                      style={{
                        borderColor: client.color,
                        backgroundColor: `${client.color}10`,
                      }}
                    >
                      <span
                        className="text-2xl font-black tracking-tighter"
                        style={{ color: client.color }}
                      >
                        {client.name}
                      </span>
                    </div>
                  ) : (
                    <img
                      src={client.img}
                      alt={client.name}
                      className="max-h-24 max-w-[200px] w-auto object-contain drop-shadow-lg transition-transform group-hover:scale-110 duration-300"
                    />
                  )}
                </div>

                {/* <span className="text-sm font-extrabold text-slate-800 tracking-widest uppercase">
                  {client.name}
                </span> */}
                <span className="text-xs font-semibold text-slate-800 tracking-wide uppercase">
                  {client.name}
                </span>
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}